// Detect touch device

export function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
}



// WEBPACK FOOTER //
// ./../src/assets/js/detect-touch-device.js